import styled from '@emotion/styled';
import { AdAnalyticsVideoIndexKeyword } from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';
import { createElement, FC, useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';

import Language from '../../../entity/Language';
import Spinner from '../../component/compound/Spinner';

type Props = {
  keywords: List<AdAnalyticsVideoIndexKeyword>;
  duration: number;
  language: Language;
  className?: string;
};

const KeywordKeyframes: FC<Props> = ({
  keywords,
  duration,
  language,
  className,
}: {
  keywords: List<AdAnalyticsVideoIndexKeyword>;
  duration: number;
  language: Language;
  className?: string;
}) => {
  const [keywordsData, updateKeywordsData] = useState([]);
  const [viewHeight, updateviewheight] = useState(0);

  useEffect(() => {
    const keywordDataNextState: any = [];
    keywordDataNextState.push([
      { type: 'string', id: 'type' },
      { type: 'string', id: 'Name' },
      { type: 'date', id: 'Start' },
      { type: 'date', id: 'End' },
    ]);
    if (keywords.size > 0) {
      keywords.map((keyword) => {
        keyword.sections.map((section) => {
          keywordDataNextState.push([
            keyword.text,
            keyword.text,
            new Date(0, 0, 0, section.start.hours, section.start.minutes, section.start.seconds),
            new Date(0, 0, 0, section.end.hours, section.end.minutes, section.end.seconds),
          ]);
        });
      });
    }
    // @TODO 一旦長さを動画時間全部出したいため
    const timeLabel = language === 'ja-JP' ? '動画時間' : 'Duration';

    keywordDataNextState.push([
      `${timeLabel}: ${duration}秒`,
      `${timeLabel}: ${duration}秒`,
      new Date(0, 0, 0, 0, 0, 0),
      new Date(0, 0, 0, 0, 0, duration),
    ]);
    updateKeywordsData(keywordDataNextState);
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // google-react-chartsが高さを自動で調節してくれないため、渡されるデータのlengthからheightを計算する
    let keywordLength = 1;

    if (keywords.size > 0) {
      keywords.map((_keyword) => {
        keywordLength = keywordLength + 1;
      });
    }
    const calcHeight = 50 + keywordLength * 40;

    updateviewheight(calcHeight > 400 ? 400 : calcHeight);
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root className={className}>
      <Chart
        width={'100%'}
        height={viewHeight}
        chartType="Timeline"
        loader={<Spinner />}
        data={keywordsData}
        options={{
          timeline: { showRowLabels: false },
        }}
        rootProps={{ 'data-testid': '1' }}
      />
    </Root>
  );
};

const Root = styled('div')({});

export default KeywordKeyframes;
